export default __webpack_public_path__ + "static/media/scrum-sfc.39386b5d.png";